
<!-- Item wrapper -->
<div class="fuse-vertical-navigation-item-wrapper mx-1 px-0 rounded"
    [class.fuse-vertical-navigation-item-has-subtitle]="!!item.subtitle" [id]="item.id"
    [ngClass]="shoudBeActive(item) ? item.active_classes?.wrapper : item.classes?.wrapper">
    <!-- Item with an internal link -->
    @if (item.link && !item.externalLink && !item.function && !item.disabled) {
    <a class="fuse-vertical-navigation-item" [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active,
            }" [routerLink]="[computedLink(item)]" [fragment]="item.fragment ?? null"
        [preserveFragment]="item.preserveFragment ?? false" [queryParams]="item.queryParams ?? null"
        [queryParamsHandling]="item.queryParamsHandling ?? null"
        [routerLinkActive]="'fuse-vertical-navigation-item-active'" [routerLinkActiveOptions]="isActiveMatchOptions"
        [matTooltip]="item.tooltip || ''">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
    }

    <!-- Item with an external link -->
    @if (item.link && item.externalLink && !item.function && !item.disabled) {
    <a class="fuse-vertical-navigation-item" [href]="item.link" [target]="item.target || '_self'"
        [matTooltip]="item.tooltip || ''">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
    }

    <!-- Item with a function -->
    @if (!item.link && item.function && !item.disabled) {
    <div class="fuse-vertical-navigation-item" [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active,
            }" [matTooltip]="item.tooltip || ''" (click)="item.function(item)">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>
    }

    <!-- Item with an internal link and function -->
    @if (item.link && !item.externalLink && item.function && !item.disabled) {
    <a class="fuse-vertical-navigation-item" [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active,
            }" [routerLink]="[item.link]" [fragment]="item.fragment ?? null"
        [preserveFragment]="item.preserveFragment ?? false" [queryParams]="item.queryParams ?? null"
        [queryParamsHandling]="item.queryParamsHandling ?? null"
        [routerLinkActive]="'fuse-vertical-navigation-item-active'" [routerLinkActiveOptions]="isActiveMatchOptions"
        [matTooltip]="item.tooltip || ''" (click)="item.function(item)">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
    }

    <!-- Item with an external link and function -->
    @if (item.link && item.externalLink && item.function && !item.disabled) {
    <a class="fuse-vertical-navigation-item" [href]="item.link" [target]="item.target || '_self'"
        [matTooltip]="item.tooltip || ''" (click)="item.function(item)">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
    }

    <!-- Item with a no link and no function -->
    @if (!item.link && !item.function && !item.disabled) {
    <div class="fuse-vertical-navigation-item" [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active,
            }" [matTooltip]="item.tooltip || ''">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>
    }

    <!-- Item is disabled -->
    @if (item.disabled) {
    <div class="fuse-vertical-navigation-item fuse-vertical-navigation-item-disabled" [matTooltip]="item.tooltip || ''">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>
    }
</div>


<!-- Item template -->
<ng-template #itemTemplate>
    <!-- Icon -->


    <!-- Icon -->
    @if (item.icon) {
    @if (typeof(item.icon) == 'string') {
    <mat-icon class="fuse-vertical-navigation-item-icon" [ngClass]="shoudBeActive(item) ? item.active_classes?.icon : item.classes?.icon"
        [class.text-red-500]="shoudBeActive(item)" [svgIcon]="item.icon"></mat-icon>
    }
    @else {
    <fa-icon [ngClass]="shoudBeActive(item) ? item.active_classes?.icon : item.classes?.icon" class="fuse-vertical-navigation-item-icon" 
        [class.icon-size-6]="!item.isChild"
        [class.icon-size-5]="item.isChild"
        [class.text-red-500]="shoudBeActive(item)"
        [icon]="item.icon"></fa-icon>
    }
    }

    <!-- Title & Subtitle -->
    <div class="fuse-vertical-navigation-item-title-wrapper" [class.text-red-500]="shoudBeActive(item)">
        <div class="fuse-vertical-navigation-item-title">
            <span [ngClass]="shoudBeActive(item) ? item.active_classes?.title : item.classes?.title">
                {{ item.title }}
            </span>
        </div>
        @if (item.subtitle) {
        <div class="fuse-vertical-navigation-item-subtitle">
            <span [ngClass]="shoudBeActive(item) ? item.active_classes?.subtitle : item.classes?.subtitle">
                {{ item.subtitle }}
            </span>
        </div>
        }
    </div>

    <!-- Badge -->
    @if (item.badge) {
    <div class="fuse-vertical-navigation-item-badge">
        <div class="fuse-vertical-navigation-item-badge-content" [ngClass]="item.badge.classes">
            {{ item.badge.title }}
        </div>
    </div>
    }
</ng-template>
<div class="fuse-vertical-navigation-item-children">
    @for (item of item.children; track trackByFn($index, item)) {
    <!-- Skip the hidden items -->
    @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
    <!-- Basic -->
    @if (item.type === 'basic') {
    <fuse-vertical-navigation-basic-item [item]="item" [name]="name"></fuse-vertical-navigation-basic-item>
    }

    <!-- Collapsable -->
    @if (item.type === 'collapsable') {
    <fuse-vertical-navigation-collapsable-item [item]="item" [name]="name"
        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-collapsable-item>
    }

    <!-- Divider -->
    @if (item.type === 'divider') {
    <fuse-vertical-navigation-divider-item [item]="item" [name]="name"></fuse-vertical-navigation-divider-item>
    }

    <!-- Group -->
    @if (item.type === 'group') {
    <fuse-vertical-navigation-group-item [item]="item" [name]="name"></fuse-vertical-navigation-group-item>
    }

    <!-- Spacer -->
    @if (item.type === 'spacer') {
    <fuse-vertical-navigation-spacer-item [item]="item" [name]="name"></fuse-vertical-navigation-spacer-item>
    }
    }
    }
</div>